import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import Select from "react-select";
import Flatpickr from "react-flatpickr";
import { toast } from 'react-toastify';
import ResponsiveTable from "../../components/ResponsiveTable";
import { EyeIcon, PencilIcon, TrashIcon, CurrencyDollarIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";
import moment from "moment"

export default function RoleList() {
  const navigate = useNavigate();
  const [filtered, setFiltered] = useState([]);
  const [categoryOption, setcategoryOption] = useState([])
  const [filters, setFilters] = useState({
    start: moment().subtract(30, "days").startOf('day').format("YYYY-MM-DD"),
    end: moment().add(1, "days").format("YYYY-MM-DD"),
    category_id: null,
  });
  const getRoleData = () => {
    axios.get("/roles").then((res) => {
      setFiltered(res.data);
    });
  }

  useEffect(() => {
    getRoleData()
  }, []);

  const capitalizeFirstLetter = (word) => {
    if (!word || typeof word !== "string") return word;
    return word.charAt(0).toUpperCase() + word.slice(1);
  };

  const actions = [
    { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
    { divider: true },
    { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
  ];
  const handleActionClick = (action, row) => {
    switch (action) {
      case "edit":
        navigate(`/expenses/edit/${row.id}`);
        break;
      case "delete":
        if (window.confirm("Are you sure you want to delete this Expenses?")) {
          axios.delete(`/expenses/${row.id}`).then((res) => {
            if (res.data.success === true) {
              toast.success(res.data.message || "Delete Expenses Successfully")
              getRoleData()
            }

          })
            .catch(err => toast.error(err.message || `Error`));
        }
        break;
      default:
        break;
    }
  };
  const handleDownload = (type) => {
    const url = `${apiBaseUrl}/purchases/export/${type}`;
    window.open(url, "_blank");
  };
  const columns = [
    { header: "SL", accessor: "sl", render: (v, row, i) => i + 1 },
    {
      header: "Date", accessor: "expense_date",
      render: (value, row) => <span>{moment(value).format("DD/MM/YYYY")}</span>
    },
    { header: "Category", accessor: "category_name" },
    { header: "Bank Name", accessor: "bank_name" },
    {
      header: "Amount", accessor: "amount",
      render: (value, row) => <span className="text-red-500">{value} BDT</span>
    },
    { header: "Note", accessor: "note" },
  ];

  return (
    <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
      <div className="w-full">
        <ExportButtons title="Expenses List" onDownload={handleDownload} />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="flex items-center rounded-md">
            <Flatpickr
              style={{
                backgroundColor: "#fff",
                opacity: "1",
                padding: "9px 12px",
              }}
              // options={{
              //   dateFormat: "d-m-Y"
              // }}
              value={filters.start}
              id="date-time-picker"
              className="form-control"
              onChange={(date) => setFilters(f => ({ ...f, start: moment(date[0]).format('YYYY-MM-DD') }))}
            />
          </div>
          <div className="flex items-center rounded-md">
            <Flatpickr
              style={{
                backgroundColor: "#fff",
                opacity: "1",
                padding: "9px 12px",
              }}
              // options={{
              //   dateFormat: "d-m-Y",
              // }}
              value={filters.end}
              id="date-time-picker"
              className="form-control"
              onChange={(date) => setFilters(f => ({ ...f, end: moment(date[0]).format('YYYY-MM-DD') }))}
            />
          </div>
          <div className="flex items-center rounded-md">
            <Select
              name="category"
              onChange={e => setFilters(f => ({ ...f, category_id: e.value }))}
              options={categoryOption}
              placeholder="Select Category"
              className="w-full"
              classNamePrefix="react-select"
              maxMenuHeight={150}
            />
          </div>
        </div>
        <ResponsiveTable
          columns={columns}
          data={filtered}
          showActions
          actionButtons={actions}
          onActionClick={handleActionClick}
        />
      </div>
    </div>
  );
}